import React, { useState } from "react";
import { FaBars, FaCog, FaNewspaper, FaTachometerAlt, FaTimes } from "react-icons/fa";
import ProfileSection from '../components/userPage/ProfileSection'
// View: Sidebar Component
const Sidebar = ({ isOpen, toggleSidebar, onLogout }) => {
  const [selectedMenu, setSelectedMenu] = useState('News'); // Track selected menu item

  const menuItems = [
    { name: 'Dashboard', icon: <FaTachometerAlt size={24} className="text-xl" /> },
    { name: 'News', icon: <FaNewspaper size={24} className="text-xl" /> },
    // { name: 'Settings', icon: <FaCog size={24} className="text-xl" /> },
  ];

  return (
    <div
      className={`bg-white text-gray-800 transition-all duration-300 shadow-lg z-1 ${isOpen ? 'w-[250px]' : 'w-[70px] group hover:w-[250px]'
        }`}
    >
      <div className="flex items-center justify-between p-3 border-b">
        <div className="flex items-center w-full">
          <button
            onClick={toggleSidebar}
            className="p-1 text-2xl bg-blue-500 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-200 hover:to-indigo-400 hover:text-gray-500 text-white rounded-md hover:bg-blue-100"
          >
            {isOpen ? <FaTimes size={32} /> : <FaBars size={32} className="py-1 px-2" title="hi" />}
          </button>
          <h2
            className={`ml-5 text-4xl font-bold transition-opacity duration-300 ${isOpen || 'group-hover:opacity-100 opacity-0'
              } ${isOpen ? 'opacity-100' : 'w-0 overflow-hidden'}`}
          >
            Admin
          </h2>
        </div>
      </div>

      <ul className="mt-4">
        {menuItems.map((item) => (
          <li
            key={item.name}
            className={`p-3 text-2xl cursor-pointer transition-colors duration-200 flex items-center ${isOpen || 'group-hover:flex-row group-hover:justify-start justify-center'
              } ${selectedMenu === item.name
                ? 'bg-blue-500 text-white'
                : 'hover:bg-blue-100 text-gray-800'
              }`}
            onClick={() => setSelectedMenu(item.name)}
          >
            <span className="flex-shrink-0">
              {React.cloneElement(item.icon, {
                className: `text-xl ${selectedMenu === item.name ? 'text-white' : 'text-gray-800'
                  }`,
              })}
            </span>
            <span
              className={`ml-2 text-2xl transition-all duration-300 ${isOpen || 'group-hover:opacity-100 group-hover:w-auto opacity-0 w-0'
                } ${isOpen ? 'opacity-100 w-auto' : 'overflow-hidden'}`}
            >
              {item.name}
            </span>
          </li>
        ))}
        <div className={`ml-2 text-2xl transition-all duration-300 ${isOpen || 'group-hover:opacity-100 group-hover:w-auto opacity-0 w-0'
          } ${isOpen ? 'opacity-100 w-auto' : 'overflow-hidden'}`}>

          <ProfileSection isOpen={selectedMenu} onLogout={onLogout} />
        </div>
      </ul>
    </div>
  );
};

export default Sidebar;